<script setup>
import {clickOutSide as vClickOutside} from "@/vClickOutside.js";
import {computed, ref, watch} from "vue";
import SearchResult from "@/Components/SearchResult.vue";
import {router} from "@inertiajs/vue3";
import debounce from "lodash-es/debounce.js";
import Spinner from "@/Components/Icons/Spinner.vue";
import MaskIcon from "@/Components/MaskIcon.vue";
import {route} from "ziggy-js";
import axios from "axios";

const open = ref(false)
const search = ref(''),
    isLoading = ref(false)

const emit = defineEmits(['onFocus', 'onClose'])
const hide = () => {
    open.value = false
    emit('onClose')
}

const products = ref([])
const showClear = computed(() => search.value && search.value.length > 0 && !isLoading.value)

let controller = null
const cancelInFlight = () => {
    if (controller) {
        controller.abort()
        controller = null
    }
}

const fetch = () => {
    const query = search.value
    open.value = true
    cancelInFlight()
    const current = new AbortController()
    controller = current
    isLoading.value = true

    axios.get(route('products.search-suggestions'), {
        params: {q: query},
        signal: current.signal,
    }).then(response => {
        if (controller !== current) return
        products.value = response.data?.data || []
    }).catch(error => {
        if (axios.isCancel(error) || controller !== current) return
        console.error('Error searching products:', error)
        products.value = []
    }).finally(() => {
        if (controller === current) {
            controller = null
            isLoading.value = false
        }
    })
}
const fetchDebounced = debounce(fetch, 1000)
watch(search, () => {
    if (search.value.length > 0) {
        fetchDebounced()
    }
})

const clearValue = () => {
    open.value = false
    search.value = ''
    cancelInFlight()
}
</script>

<template>
        <div class="relative py-2" v-click-outside="hide">
            <div class="flex">
                <label for="default-search"
                       class="mb-2 text-sm font-medium text-gray-900 sr-only dark:text-white">Search</label>
                <div class="relative w-full">
                    <div class="absolute inset-y-0 left-0 flex items-center pl-3 pointer-events-none">
                        <MaskIcon src="/assets/icons/search.svg" class="w-4 h-[17px] bg-[#131933] dark:bg-slate-400"/>
                    </div>
                    <input type="text"
                           class="block w-full pl-9 placeholder:font-medium font-medium p-1 dark:placeholder-slate-400 lg:py-2 dark:bg-dark-blue text-base lg:text-sm text-gray-900 dark:text-slate-500 border border-slate-400 rounded-full bg-gray-50 focus:ring-blue-600 focus:border-blue-600"
                           :placeholder="$t('Search games, subscriptions, etc.')" required
                           v-model="search"
                           @focus="emit('onFocus')"
                           @keyup.enter="router.get(route('products.index', {search: search ? search : undefined}))"
                    >
                    <!--                    <button type="submit"-->
                    <!--                            class="text-white absolute right-2.5 bottom-2.5 bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-hidden focus:ring-blue-300 font-medium rounded-lg text-sm px-4 py-2 dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800">-->
                    <!--                        Искать-->
                    <!--                    </button>-->
                    <div v-if="isLoading" class="absolute inset-y-0 right-0 flex">
                        <Spinner class="self-center"/>
                    </div>
                    <div v-if="showClear"
                         class="absolute inset-y-0 right-0 flex items-center pr-3 z-10 text-slate-500 cursor-pointer"
                         @click="clearValue"
                    >
                        <ion-icon name="close-circle" class="text-xl" style="width: 20px; height: 20px"></ion-icon>
                    </div>
                </div>
            </div>
            <SearchResult v-if="!isLoading && open" :search-result="products" :search="search"/>
        </div>
</template>
